import * as types from "../../actions/actionTypes";
import { WITHOUT_HASHTAG } from "../../constants/hashtags";
const initialState = {
  loading: true,
  data: { data: [], meta: {} },
  allPagesData: [],
  allPagesLoading: true
};

const PettyCashierHashtagReport = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASHIER_GET_HASHTAG_SUMMARY_REQUEST:
      return { ...state, loading: true };
    case types.PETTY_CASHIER_GET_HASHTAG_SUMMARY_SUCCESS:
      return { ...state, loading: false, data: action.payLoad };
    case types.PETTY_CASHIER_GET_HASHTAG_SUMMARY_FAILURE:
      return { ...state, loading: false };

    case types.PETTY_CASHIER_GET_ALL_HASHTAG_USED_REQUEST:
      return { ...state, allPagesLoading: true };
    case types.PETTY_CASHIER_GET_ALL_HASHTAG_USED_SUCCESS:
      let data = action.payLoad.map(item => {
        return { id: item.id, name: item.name, color: item.color };
      });
      return { ...state, allPagesLoading: false, allPagesData: data };
    case types.PETTY_CASHIER_GET_ALL_HASHTAG_USED_FAILURE:
      return { ...state, allPagesLoading: false };
    default:
      return state;
  }
};

export default PettyCashierHashtagReport;
